import { FiltersForm, SwitchForm } from '@jobcost-monorepo/ui';
import React from 'react';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import { ISearch } from '..';
import DropdownCrud from '@jobcost-monorepo/crud/ui/DropdownCrud';
import { MN_CUSTOMERS, MN_JOBS, MN_RESOURCES } from '@jobcost-monorepo/crud';
import { ITimesheetsReportGlobal } from '@jobcost-monorepo/utils';
import { IReportGlobalTimesheetFetchParams } from '../../types';

interface Props {
  isOpen: boolean;
  onSubmit: SubmitHandler<ISearch>;
  handleClose: () => void;
}

const FiltersTimesheetGlobal: React.FC<Props> = ({
  isOpen,
  onSubmit,
  handleClose,
}) => {
  const methods = useFormContext<ISearch>();

  const { getValues, setValue } = methods;

  const handleResetFilters = async () => {
    setValue('isEmployee', undefined);
    setValue('resourceId', undefined);
    setValue('customerId', undefined);
    setValue('jobId', undefined);
    onSubmit({
      ...getValues(),
      isEmployee: undefined,
      resourceId: undefined,
      customerId: undefined,
      jobId: undefined,
    });
    handleClose();
  };

  const handleFilter = async () => {
    const data = getValues();
    onSubmit(data);
    handleClose();
  };

  return (
    <FiltersForm
      isOpen={isOpen}
      handleClose={handleClose}
      handleResetFilters={handleResetFilters}
      handleFilter={handleFilter}
    >
      <div className="p-4">
        <SwitchForm
          id="isEmployee"
          name="isEmployee"
          label="Solo dipendenti"
          disabled={false}
          width="w-full"
        />
        <DropdownCrud<
          ITimesheetsReportGlobal,
          IReportGlobalTimesheetFetchParams
        >
          moduleName={MN_RESOURCES}
          linkedField="resourceId"
          linkedFieldForDefaultValue="resource.name"
          label={'Risorsa'}
          width="w-full"
        />
        <DropdownCrud<
          ITimesheetsReportGlobal,
          IReportGlobalTimesheetFetchParams
        >
          moduleName={MN_CUSTOMERS}
          linkedField="customerId"
          linkedFieldForDefaultValue="customer.name"
          label={'Cliente'}
          width="w-full"
        />
        <DropdownCrud<
          ITimesheetsReportGlobal,
          IReportGlobalTimesheetFetchParams
        >
          moduleName={MN_JOBS}
          linkedField="jobId"
          linkedFieldForDefaultValue="job.code"
          label={'Commessa'}
          width="w-full"
        />
      </div>
    </FiltersForm>
  );
};

export default FiltersTimesheetGlobal;
